import { ChannelValidators } from './../../../core/validators/channel.validators';
import { UntypedFormBuilder, Validators, ValidationErrors, UntypedFormControl } from '@angular/forms';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { merge } from 'lodash';
import { Observable } from 'rxjs';
import { ChannelCategoryEdit } from '../../model/channelCategoryEdit';
import { DictionaryService } from 'src/app/core/service/dictionary.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { ChannelCategoryService } from 'src/app/core/service/channel-category.service';

@Component({
  standalone: false,
  selector: 'app-channel-category-edit',
  templateUrl: './channel-category-edit.component.html',
  styleUrls: ['./channel-category-edit.component.scss']
})
export class ChannelCategoryEditComponent implements OnInit
{
  @Input() public isNew = false;

  @Output() public cancelling: EventEmitter<any> = new EventEmitter();
  @Output() public save: EventEmitter<ChannelCategoryEdit> = new EventEmitter();

  public editForm: any;
  public editFormActive = false;
  public codeSets: any[];

  private channelCategoryEdit: ChannelCategoryEdit;

  constructor(
    private fb: UntypedFormBuilder,
    private messageHandlerService: MessageHandlerService,
    private channelCategoryService: ChannelCategoryService,
    private dictionaryService: DictionaryService,
    private channelValidators: ChannelValidators) { }

  public get name(): UntypedFormControl
  {
    return this.editForm.get('name');
  }

  public get channelWorkflowStatus(): UntypedFormControl
  {
    return this.editForm.get('channelWorkflowStatus');
  }

  @Input() public set model(channelCategory: ChannelCategoryEdit)
  {
    this.initModel(channelCategory);
  }

  public ngOnInit(): void
  {
    // fetch code sets from server
    this.dictionaryService.getCodeSets().subscribe({
      next: (data) =>
      {
        this.codeSets = data;
      },
      error: (error) =>
      {
        this.messageHandlerService.displayError(error);
      }
    });
  }

  public onSave(e: Event): void
  {
    e.preventDefault();
    const objectToPersist = merge(this.channelCategoryEdit, this.editForm.value);

    this.save.emit(objectToPersist);
    this.editFormActive = false;
  }

  public onCancel(e: Event): void
  {
    e.preventDefault();
    this.closeEditForm();
  }

  private closeEditForm(): void
  {
    this.editFormActive = false;
    this.cancelling.emit();
  }

  private initModel(channelCategory: ChannelCategoryEdit)
  {
    if (channelCategory === undefined)
    {
      return;
    }

    if (this.isNew)
    {
      this.buildForm(channelCategory, false);
    }
    else
    {
      this.channelCategoryService.existsChannelCategory(channelCategory.id).subscribe({
        next: (inUseResponse) =>
        {
          this.buildForm(channelCategory, inUseResponse);
        }
      });
    }
  }

  private buildForm(channelCategory: ChannelCategoryEdit, inUseChannelCategory: boolean): void
  {
    // Set the current channel category id used for name async validators
    const previousChannelCategoryName = this.isNew ? '' : channelCategory.name;

    // Set form
    this.editForm = this.fb.group({
      id: [null],
      name: [
        { value: '', disabled: false },
        {
          validators: [Validators.required],
          asyncValidators: (): Observable<ValidationErrors | null> =>
            this.channelValidators.validateChannelCategoryNameUnique(this.editForm.get('name'), previousChannelCategoryName)
        }
      ],
      active: { value: true, disabled: false },
      channelWorkflowStatus: [{ value: channelCategory.channelWorkflowStatus, disabled: inUseChannelCategory }, Validators.required]
    });

    this.editForm.reset(channelCategory);
    this.channelCategoryEdit = channelCategory;
    this.editFormActive = channelCategory !== undefined;
  }
}
